import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/i18n";
import { SeoHreflang } from "@/components/SeoHreflang";
import Home from "@/pages/Home";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import GalleryPage from "@/pages/GalleryPage";
import AdminGallery from "@/pages/AdminGallery";
import ResetPassword from "@/pages/ResetPassword";

function Redirect({ to }) {
  useEffect(() => { window.location.replace(to); }, [to]);
  return null;
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <SeoHreflang />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/galeria" element={<GalleryPage />} />
            <Route path="/ochrana-osobnych-udajov" element={<PrivacyPolicy />} />
            <Route path="/admin" element={<AdminGallery />} />
            <Route path="/admin/reset" element={<ResetPassword />} />
            <Route path="/kontakt" element={<Redirect to="/#contact" />} />
            <Route path="*" element={<Redirect to="/" />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
